import { useState, useEffect, useCallback } from 'react';

import useGetTotalEatenBaitLineChart from './useGetTotalEatenBaitChartData';

import { Period } from 'components/AnalyticsPage/Periods';
import { Steps } from 'components/AnalyticsPage/Spets';

interface ChartData {
  week_or_month_name: string[];
  amount: number[];
}

interface UseChartDataProps {
  slug: string;
}

export const useGetTotalEatenBaitLineChartState = ({ slug }: UseChartDataProps) => {
  const [period, setPeriod] = useState<Period>(Period.YEAR);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [showCustom, setShowCustom] = useState<boolean>(true);
  const [step, setStep] = useState<string>(Steps.DAY);

  const { data, refetch, isLoading, isFetching } = useGetTotalEatenBaitLineChart(
    slug,
    period,
    step,
    startDate,
    endDate,
    false,
  );

  const [chartData, setChartData] = useState<ChartData>({
    week_or_month_name: [],
    amount: [],
  });

  useEffect(() => {
    if (data) {
      const week_or_month_name = data.map((item: any) => item.week_or_month_name);
      const amount = data.map((item: any) => item.amount);

      setChartData({ week_or_month_name, amount });
    }
  }, [data]);

  useEffect(() => {
    const currentPath = window.location.pathname;

    if (!currentPath.includes('analitics')) {
      return;
    }

    if (startDate && endDate) {
      const timer = setTimeout(() => {
        refetch();
      }, 1000);

      return () => clearTimeout(timer);
    } else if (period !== 'CUSTOM') {
      refetch();
    }
  }, [startDate, endDate, period, refetch]);

  const handlePeriodChange = useCallback((newPeriod: Period) => {
    if (newPeriod === 'CUSTOM') {
      const today = new Date();
      const oneYearBefore = new Date();
      oneYearBefore.setFullYear(today.getFullYear() - 1);

      setStartDate(oneYearBefore.toISOString().split('T')[0]);
      setEndDate(today.toISOString().split('T')[0]);
      setShowCustom(false);
    } else {
      setStartDate('');
      setEndDate('');
      setShowCustom(true);
    }
    setPeriod(newPeriod);
  }, []);

  return {
    period,
    startDate,
    endDate,
    showCustom,
    chartData,
    isLoading,
    isFetching,
    handlePeriodChange,
    setStartDate,
    setEndDate,
    step,
    setStep,
    refetch,
  };
};
